import { render, staticRenderFns } from "./PaPagination.vue?vue&type=template&id=6757c426"
import script from "./PaPagination.vue?vue&type=script&lang=js"
export * from "./PaPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports